<template>
  <div class="bidding-plan-list">
    <div class="page-header">
      <h2 class="page-title">采购计划</h2>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-form">
        <label class="search-label">采购计划标题:</label>
        <el-input 
          v-model="searchForm.noticeName" 
          placeholder="请输入采购计划标题" 
          class="search-input" 
          clearable 
          @keyup.enter.native="handleSearch"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
          搜索
        </el-button>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">
          添加采购计划
        </el-button>
      </div>
    </div>
    
    <!-- 数据表格 -->
    <div class="table-section">
      <el-table 
        :data="tableData" 
        v-loading="loading" 
        border 
        style="width: 100%" 
        class="data-table"
        :header-cell-style="{ backgroundColor: '#f5f7fa', fontWeight: 'bold' }"
      >
        <el-table-column prop="no" label="NO." width="80" align="center">
          <template slot-scope="scope">
            {{ (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="noticeName" label="采购计划标题" min-width="300" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="title-text">{{ scope.row.noticeName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="region" label="省市区" min-width="200" align="center">
          <template slot-scope="scope">
            <span class="region-text">
              {{ formatRegion(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
              查看
            </el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" class="action-btn delete-btn">
              删除
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    
    <!-- 分页 -->
    <div class="pagination-section">
      <el-pagination 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" 
        :page-sizes="[10, 20, 50, 100]" 
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" 
        :total="pagination.total" 
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import { getPlanNoticePage } from '@/api/modules/agent'

export default {
  name: 'BiddingPlanList',
  data() {
    return {
      loading: false,
      searchForm: {
        noticeName: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 格式化地区显示
    formatRegion(row) {
      const parts = []
      if (row.provinceName) parts.push(row.provinceName)
      if (row.cityName) parts.push(row.cityName)
      if (row.countyName) parts.push(row.countyName)
      return parts.length > 0 ? parts.join(' | ') : '-'
    },
    
    // 添加采购计划
    handleAdd() {
      this.$router.push({ name: 'addbiddingplan' })
    },
    
    // 加载数据
    loadData() {
      this.loading = true
      const params = {
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        noticeName: this.searchForm.noticeName
      }
      getPlanNoticePage(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records || []
          this.pagination.total = res.data.total || 0
          this.pagination.currentPage = res.data.current || 1
        } else {
          this.$message.error(res.msg || '获取数据失败')
          this.tableData = []
          this.pagination.total = 0
        }
        this.loading = false
      }).catch(error => {
        console.error('获取采购计划列表失败:', error)
        this.$message.error('获取数据失败')
        this.tableData = []
        this.pagination.total = 0
        this.loading = false
      })
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    
    // 查看详情
    handleView(row) {
      this.$router.push({ name: 'addbiddingplan', query: { id: row.id, type: 'view' } })
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该采购计划吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里可以添加删除接口
        this.$message.success('删除成功')
        this.loadData()
      }).catch(() => {})
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style lang="less" scoped>
.bidding-plan-list {
  padding: 20px;
  min-height: calc(100vh - 84px);
  background: #f5f7fa;
}

.page-header {
  margin-bottom: 20px;
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
  }
}

.search-section {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  
  .search-form {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }
  
  .search-label {
    font-size: 14px;
    color: #606266;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .search-input {
    width: 240px;
  }
  
  .search-btn {
    margin-left: 8px;
  }
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  
  .data-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    
    /deep/ .el-table__header-wrapper {
      th {
        background-color: #f5f7fa !important;
      }
    }
    
    /deep/ .el-table__body-wrapper {
      .el-table__row {
        &:hover > td {
          background-color: #f5f7fa;
        }
      }
    }
    
    .title-text {
      color: #409eff;
      cursor: pointer;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    .region-text {
      color: #606266;
      font-size: 13px;
    }
    
    .action-btn {
      padding: 4px 8px;
      font-size: 13px;
      
      &.delete-btn {
        color: #f56c6c;
        
        &:hover {
          color: #f56c6c;
        }
      }
    }
  }
}

.pagination-section {
  margin-top: 20px;
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: flex-end;
  
  .pagination {
    /deep/ .el-pager li {
      &:hover {
        color: #409eff;
      }
      
      &.active {
        background-color: #409eff;
        color: #fff;
      }
    }
  }
}

// 响应式适配
@media (max-width: 768px) {
  .bidding-plan-list {
    padding: 12px;
  }
  
  .search-section {
    padding: 16px;
    
    .search-form {
      flex-direction: column;
      align-items: stretch;
    }
    
    .search-input {
      width: 100%;
    }
    
    .search-btn {
      margin-left: 0;
      width: 100%;
    }
  }
  
  .table-section {
    padding: 12px;
    overflow-x: auto;
  }
  
  .pagination-section {
    padding: 12px;
    justify-content: center;
  }
}
</style>
